<!-- ================管理端-创建编辑专题活动====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">{{!activityId?'创建专题活动':'编辑专题活动'}}</div>
        </div>
        <div class="create-content-container">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <div class="info-content-container">
                    <div class="topic-title-container">
                        <div class="topic-title-container1">
                            <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547002 0-21.304212 9.265924-39.626466 26.238594-52.547002 17.759479-14.213723 38.871311-21.304212 63.305815-21.304212 24.434505 0 45.540196 7.090489 62.768579 21.304212 17.759479 14.213723 26.238594 31.710212 26.238594 52.547002 0 21.304212-8.479115 39.626466-26.238594 52.547002z" fill="#377f7f" p-id="12410"></path></svg>
                        </div>
                        <div class="topic-title-container2">基础信息</div>
                    </div>
                    <el-row>
                        <el-col :span="15">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="活动名称" prop="activityName">
                                        <el-input v-model="form.activityName" placeholder="请输入活动名称，最多50个字" maxlength="50" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="活动方向" prop="activityDirection">
                                        <el-select style="width: 100%;" v-model="form.activityDirection" placeholder="请选择活动方向">
                                            <el-option v-for="item in activityDirList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-icon @click="createActivityDirection" class="ml15 cursor" :size="30">
                                        <CirclePlus />
                                    </el-icon>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label="学段" prop="periodKey">
                                        <el-select @change="changePeriod" v-model="form.periodKey" placeholder="请选择">
                                            <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="年级" prop="gradeKey">
                                        <el-select @change="changeGrade" v-model="form.gradeKey" placeholder="请选择">
                                            <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="学科" prop="subjectKey">
                                        <el-select v-model="form.subjectKey" placeholder="请选择">
                                            <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="活动级别" prop="activityLevel">
                                        <el-select style="width: 100%;" v-model="form.activityLevel" placeholder="请选择活动级别">
                                            <el-option v-for="item in activityLevelList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="18">
                                    <el-form-item label="主办单位" prop="hostOrg">
                                        <el-select style="width: 100%;" filterable v-model="form.hostOrg" placeholder="请选择主办单位">
                                            <el-option v-for="item in orgList" :key="item.orgId" :label="item.orgName" :value="item.orgId" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="18">
                                    <el-form-item label="联系方式" prop="contactInfo">
                                        <el-input v-model="form.contactInfo" placeholder="请输入联系方式" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="18">
                                    <el-form-item label="展示类型" prop="activityType">
                                        <el-radio-group v-model="form.activityType">
                                            <el-radio :label="0">文字展示</el-radio>
                                            <el-radio :label="1">图片展示</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="活动负责人" prop="leadUsersList">
                                        <choosePeople :showTitle="'选择人员'" :radio="true" ref="leadUsersList" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="20">
                                    <el-form-item label="报名阶段" prop="applyFormTime">
                                        <el-col :span="11" class="date_picker">
                                            <el-date-picker format="YYYY-MM-DD HH:mm" :disabled-date="disabledDate" style="width: 100%;" v-model="form.beginTime" type="datetime" placeholder="开始时间" value-format="x" />
                                        </el-col>
                                        <el-col :span="2" class="text-center">
                                            <span class="text-gray-500">至</span>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker" style="width: 100%;" v-model="form.endTime" type="datetime" placeholder="结束时间" value-format="x" />
                                        </el-col>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="审核模式" prop="checkMode">
                                        <el-select style="width: 100%;" v-model="form.checkMode" @change="changeCheckMode" placeholder="请选择审核模式">
                                            <el-option v-for="item in checkModeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row v-show="form.checkMode==='2'||form.checkMode==='3'">
                                <el-col :span="24">
                                    <el-form-item label="初审审核人" prop="csCheckUsersList">
                                        <choosePeople :showTitle="'选择人员'" ref="csCheckUsersList" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row v-show="form.checkMode==='3'">
                                <el-col :span="24">
                                    <el-form-item label="复审审核人" prop="fsCheckUsersList">
                                        <choosePeople :showTitle="'选择人员'" ref="fsCheckUsersList" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="终审审核人" prop="zsCheckUsersList">
                                        <choosePeople :showTitle="'选择人员'" ref="zsCheckUsersList" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row v-if="form.checkMode==='2'||form.checkMode==='3'">
                                <el-col :span="20">
                                    <el-form-item label="初审阶段" prop="csCheckFormTime">
                                        <el-col :span="11" class="date_picker">
                                            <el-date-picker format="YYYY-MM-DD HH:mm" :disabled-date="disabledDate" style="width: 100%;" v-model="form.csBeginTime" type="datetime" placeholder="开始时间" value-format="x" />
                                        </el-col>
                                        <el-col :span="2" class="text-center">
                                            <span class="text-gray-500">至</span>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker" style="width: 100%;" v-model="form.csEndTime" type="datetime" placeholder="结束时间" value-format="x" />
                                        </el-col>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row v-if="form.checkMode==='3'">
                                <el-col :span="20">
                                    <el-form-item label="复审阶段" prop="fsCheckFormTime">
                                        <el-col :span="11" class="date_picker">
                                            <el-date-picker format="YYYY-MM-DD HH:mm" :disabled-date="disabledDate" style="width: 100%;" v-model="form.fsBeginTime" type="datetime" placeholder="开始时间" value-format="x" />
                                        </el-col>
                                        <el-col :span="2" class="text-center">
                                            <span class="text-gray-500">至</span>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker" style="width: 100%;" v-model="form.fsEndTime" type="datetime" placeholder="结束时间" value-format="x" />
                                        </el-col>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="20">
                                    <el-form-item label="终审阶段" prop="zsCheckFormTime">
                                        <el-col :span="11" class="date_picker">
                                            <el-date-picker format="YYYY-MM-DD HH:mm" :disabled-date="disabledDate" style="width: 100%;" v-model="form.zsBeginTime" type="datetime" placeholder="开始时间" value-format="x" />
                                        </el-col>
                                        <el-col :span="2" class="text-center">
                                            <span class="text-gray-500">至</span>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker" style="width: 100%;" v-model="form.zsEndTime" type="datetime" placeholder="结束时间" value-format="x" />
                                        </el-col>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="20">
                                    <el-form-item label="上传附件" prop="">
                                        <el-upload v-model:file-list="fileList" style="width: 100%"
                                                   :action="serviceUrl+'/businessservice/activity/uploadFile'"
                                                   :on-change="handleFileChange" :headers="{ token }" accept=".pdf,.ppt,.pptx,.doc,.docx"
                                                   :before-upload="beforeFileUpload">
                                            <el-button type="primary">点击上传</el-button>
                                            <template #tip>
                                                <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                            </template>
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div class="topic-title-container">
                                <div class="topic-title-container1">
                                    <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547002 0-21.304212 9.265924-39.626466 26.238594-52.547002 17.759479-14.213723 38.871311-21.304212 63.305815-21.304212 24.434505 0 45.540196 7.090489 62.768579 21.304212 17.759479 14.213723 26.238594 31.710212 26.238594 52.547002 0 21.304212-8.479115 39.626466-26.238594 52.547002z" fill="#377f7f" p-id="12410"></path></svg>
                                </div>
                                <div class="topic-title-container2">活动详情</div>
                            </div>
                            <el-row v-if="form.activityType === 0">
                                <el-col :span="20">
                                    <el-form-item label="活动介绍" prop="activityContent">
                                        <el-input type="textarea" rows="4" v-model="form.activityContent" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row v-if="form.activityType === 0">
                                <el-col :span="20">
                                    <el-form-item label="报名要求" prop="activityRule">
                                        <el-input type="textarea" rows="4" v-model="form.activityRule" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row v-if="form.activityType === 1">
                                <el-col :span="12">
                                    <el-form-item label="详情图片" prop="imgUrl">
                                        <el-upload class="avatar-uploader"
                                                   :action="serviceUrl+'/businessservice/activity/uploadImg'"
                                                   :show-file-list="false" :on-success="handleAvatarSuccess" :headers="{ token }"
                                                   :before-upload="beforeAvatarUpload">
                                            <img alt="" v-if="form.imgUrl" :src="form.imgUrl" class="avatar" style="position:absolute" />
                                            <el-icon class="avatar-uploader-icon" style="font-size:60px;">
                                                <Plus />
                                            </el-icon>
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div class="topic-title-container">
                                <div class="topic-title-container1">
                                    <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547002 0-21.304212 9.265924-39.626466 26.238594-52.547002 17.759479-14.213723 38.871311-21.304212 63.305815-21.304212 24.434505 0 45.540196 7.090489 62.768579 21.304212 17.759479 14.213723 26.238594 31.710212 26.238594 52.547002 0 21.304212-8.479115 39.626466-26.238594 52.547002z" fill="#377f7f" p-id="12410"></path></svg>
                                </div>
                                <div class="topic-title-container2">量表设置</div>
                            </div>
                            <el-row v-if="form.checkMode === '3'">
                                <el-col :span="12">
                                    <el-form-item label="复审量表" prop="scaleIds">
                                        <el-select style="width:100%" filterable v-model="form.scaleIds" placeholder="请选择复审量表">
                                            <el-option v-for="item in fsScaleList" :key="item.scaleId" :label="item.scaleName" :value="item.scaleId">
                                                <span style="float: left">{{ item.scaleName }}</span>
                                                <span @click.stop="previewScale(item)" style="float: right; color: #8492a6; font-size: 13px">
                                                    <el-icon><View /></el-icon>
                                                </span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="终审量表" prop="zsScaleIds">
                                        <el-select style="width:100%" filterable v-model="form.zsScaleIds" placeholder="请选择终审量表">
                                            <el-option v-for="item in zsScaleList" :key="item.scaleId" :label="item.scaleName" :value="item.scaleId">
                                                <span style="float: left">{{ item.scaleName }}</span>
                                                <span @click.stop="previewScale(item)" style="float: right; color: #8492a6; font-size: 13px">
                                                    <el-icon><View /></el-icon>
                                                </span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div class="topic-title-container">
                                <div class="topic-title-container1">
                                    <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547002 0-21.304212 9.265924-39.626466 26.238594-52.547002 17.759479-14.213723 38.871311-21.304212 63.305815-21.304212 24.434505 0 45.540196 7.090489 62.768579 21.304212 17.759479 14.213723 26.238594 31.710212 26.238594 52.547002 0 21.304212-8.479115 39.626466-26.238594 52.547002z" fill="#377f7f" p-id="12410"></path></svg>
                                </div>
                                <div class="topic-title-container2">现场评比</div>
                                <div class="topic-title-container3">
                                    <el-switch v-model="form.isEva" class="ml-2" :active-value="Number(1)" :inactive-value="Number(0)" style="--el-switch-on-color: #377f7f;" />
                                </div>
                            </div>
                            <el-row class="mt5" v-if="form.isEva === 1">
                                <el-col :span="12">
                                    <el-form-item label="评比权重" prop="evaWeight">
                                        <el-input-number v-model="form.evaWeight" step-strictly min="10" max="100" step="10">
                                            <template #suffix>%</template>
                                        </el-input-number>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row v-if="form.isEva === 1">
                                <el-col :span="20">
                                    <el-form-item label="评比时间" prop="pbCheckFormTime">
                                        <el-col :span="11" class="date_picker">
                                            <el-date-picker format="YYYY-MM-DD HH:mm" :disabled-date="disabledDate" style="width: 100%;" v-model="form.evaBeginTime" type="datetime" placeholder="开始时间" value-format="x" />
                                        </el-col>
                                        <el-col :span="2" class="text-center">
                                            <span class="text-gray-500">至</span>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker" style="width: 100%;" v-model="form.evaEndTime" type="datetime" placeholder="结束时间" value-format="x" />
                                        </el-col>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row v-if="form.isEva === 1">
                                <el-col :span="20">
                                    <el-form-item label="评比地址" prop="evaAddress">
                                        <el-input v-model="form.evaAddress" placeholder="请使用地图选择评比地址" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="1"></el-col>
                        <el-col :span="8">
                            <el-form-item label="" prop="activityCover" label-position="top">
                                <el-upload class="event-avatar-uploader"
                                           :action="serviceUrl+'/businessservice/train/uploadCover'" :show-file-list="false"
                                           :on-success="handleCoverSuccess" :headers="{ token }" :before-upload="beforeAvatarUpload">
                                    <img alt="" v-if="form.activityCover" :src="form.activityCover" class="avatar" style="position:absolute" />
                                    <el-icon class="event-avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                        <Plus />
                                    </el-icon>
                                </el-upload>
                                <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="form.isEva === 1">
                        <el-col :span="20">
                            <el-form-item label="">
                                <aMap v-if="isShow" ref="zdyMap" style="width: 100%" @getGeocoder="getGeocoder" :oldCenter="oldCenter" :isShowAMap="true"></aMap>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <div class="dis-flex-row-center cus-btn">
                <el-button type="primary" @click="submitActivity">确 定</el-button>
                <el-button @click="backList">取 消</el-button>
            </div>
        </div>

        <el-dialog :title="'活动方向'" v-model="dirNameShow" width="50%">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="名称" prop="dirName">
                        <el-input v-model="dirName" placeholder="最多6个字" maxlength="6" />
                    </el-form-item>
                </el-col>
            </el-row>
            <template #footer>
                <div class="dis-flex-row-center">
                    <el-button type="primary" @click="submitDirName">确 定</el-button>
                    <el-button @click="dirNameShow = false">取 消</el-button>
                </div>
            </template>
        </el-dialog>

        <el-dialog :title="scaleInfo.scaleName+'预览'" v-model="isViewScaleShow" width="60%">
            <div class="mb30" v-for="(item, index) in scaleInfo.eduItemList" :key="item" style="width: 98%">
                <div>
                    <h3 style="margin: 0 0;">
                        <span style="padding-right: 10px;">{{ index + 1 }}.{{item.itemName }}</span>
                        <span style="color: #efa030;font-weight: normal;font-size: 14px;">(满分：{{item.itemScore }})</span>
                    </h3>
                </div>
                <div>
                    <el-radio-group disabled class="ml-4">
                        <el-radio label="1" size="small" :key="items" v-for="items in item.itemList">
                            <span style="color: #333;">{{ items.itemName }}</span>
                            <span style="color: #efa030;">(分值：{{ items.itemScore }})</span>
                        </el-radio>
                    </el-radio-group>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global"
import { queryDict } from "@/api/admin/dict";
import { queryUserManagerOrg } from "@/api/admin/org"
import aMap from "@/components/aMap/index.vue";
import choosePeople from "@/components/choosePeople.vue";
import { activityCreate, activityUpdate, addActivityDirection, activityInfo } from "@/api/admin/activity";
import { listScale, infoScale } from "@/api/admin/eduScale"
import { ElLoading } from 'element-plus'

export default {
    name: "activityCreate",
    components: { aMap, choosePeople },
    data() {
        return {
            serviceUrl,
            activityId: '',
            dirName: '',
            dirNameShow: false,
            isViewScaleShow: false,
            fileList: [],
            isShow: false,
            oldCenter: [],
            periodList: [],
            gradeList: [],
            subjectList: [],
            orgList: [],
            activityLevelList: [],
            activityDirList: [],
            checkModeList: [],
            token: this.$storage.get("token"),
            loading: false,
            single: true,
            form: {
                activityId: '',
                activityName: '',
                activityCover: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/szpx.png',
                activityNature: '1',
                activityDirection: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                activityLevel: '',
                hostOrg: '',
                contactInfo: '',
                activityType: 0,
                activityLeader: '',
                beginTime: '',
                endTime: '',
                checkUsers: '',
                checkMode: '1',
                csBeginTime: '',
                csEndTime: '',
                csCheckUsers: '',
                fsBeginTime: '',
                fsEndTime: '',
                fsCheckUsers: '',
                zsBeginTime: '',
                zsEndTime: '',
                zsCheckUsers: '',
                activityContent: '',
                activityRule: '',
                scaleIds: '',
                zsScaleIds: '',
                imgUrl: '',
                isEva: 0,
                evaWeight: '',
                evaBeginTime: '',
                evaEndTime: '',
                evaAddress: '',
                lng: '',
                lat: '',
                leadUsersList: [],
                csCheckUsersList: [],
                fsCheckUsersList: [],
                zsCheckUsersList: [],
                fileUrls: '',
            },
            rules: {
                activityName: [{ required: true, message: "请输入活动名称", trigger: "blur" },],
                activityDirection: [{ required: true, message: "请选择活动方向", trigger: "change" }],
                activityLevel: [{ required: true, message: "请选择活动级别", trigger: "change" },],
                hostOrg: [{ required: true, message: "请选择主办单位", trigger: "change" },],
                activityType: [{ required: true, message: "请选择展示类型", trigger: "change" },],
                leadUsersList: [{ required: true, validator: this.verifyLeadUsersList },],
                applyFormTime: [{ required: true, validator: this.verifyApplyFormTime }],
                checkMode: [{ required: true, message: "请选择审核模式", trigger: "change" },],
                csCheckUsersList: [{ required: true, validator: this.verifyCsCheckUsersList },],
                fsCheckUsersList: [{ required: true, validator: this.verifyFsCheckUsersList },],
                zsCheckUsersList: [{ required: true, validator: this.verifyZsCheckUsersList },],
                csCheckFormTime: [{ required: true, validator: this.verifyCsCheckFormTime }],
                fsCheckFormTime: [{ required: true, validator: this.verifyFsCheckFormTime }],
                zsCheckFormTime: [{ required: true, validator: this.verifyZsCheckFormTime }],
                activityContent: [{ required: true, message: "请输入活动介绍", trigger: "blur" },],
                activityRule: [{ required: true, message: "请输入报名要求", trigger: "blur" },],
                scaleIds: [{ required: true, message: "请选择复审量表", trigger: "change" },],
                zsScaleIds: [{ required: true, message: "请选择终审量表", trigger: "change" },],
                evaWeight: [{ required: true, message: "请输入评比权重", trigger: "blur" },],
                evaAddress: [{ required: true, message: "请输入现场评比地址", trigger: "blur" },],
                pbCheckFormTime: [{ required: true, validator: this.verifyPbCheckFormTime }],
                imgUrl: [{ required: true, validator: this.checkCoverValidator }],
            },
            delFileList: [],
            fsScaleList: [],
            zsScaleList: [],
            queryForm: {
                businessType: 2,
                scaleType: 1,
            },
            scaleInfo: {},
            role: this.$storage.get("role"),
        };
    },
    created() {
        this.queryDict()
        this.queryActivityScaleList();
        this.queryOrgList();
    },
    mounted() {
        if (this.$route.query.activityId) {
            this.activityId = this.$route.query.activityId
            this.queryActivityInfo()
        } else {
            this.isShow = true
        }
    },
    unmounted() {},
    computed: {},
    methods: {
        queryActivityInfo() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(respon => {
                this.periodList = respon.data.data;
                activityInfo({ activityId: this.activityId }).then(res => {
                    this.form = res.data.data;
                    this.$refs.leadUsersList.checkList = this.form.leadUserList;
                    this.$refs.zsCheckUsersList.checkList = this.form.zsCheckUserList;
                    if (this.form.checkMode === '2') {
                        this.$refs.csCheckUsersList.checkList = this.form.csCheckUserList;
                    }
                    if (this.form.checkMode === '3') {
                        this.$refs.csCheckUsersList.checkList = this.form.csCheckUserList;
                        this.$refs.fsCheckUsersList.checkList = this.form.fsCheckUserList;
                    }
                    this.periodList.forEach(j => {
                        if (this.form.periodKey === j.dictKey) {
                            this.gradeList = j.childrenList;
                        }
                    })
                    this.periodList.forEach(e => {
                        if (this.form.periodKey === e.dictKey) {
                            e.childrenList.forEach(j => {
                                if (this.form.gradeKey === j.dictKey) {
                                    this.subjectList = j.childrenList;
                                }
                            })
                        }
                    })
                    this.form.fileList.forEach(e => {
                        this.fileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code: 1,
                                data: e.fileUrl
                            }
                        })
                    })
                    this.isShow = true;
                })
            })
        },
        queryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'activity_level' }).then(res => {
                this.activityLevelList = res.data.data;
                if (this.role != 1 && this.role != 2) {
                    const list = [];
                    this.activityLevelList.forEach(e => {
                        if (e.dictKey == 5) {
                            list.push(e);
                        }
                    })
                    this.activityLevelList = list;
                }
            })
            queryDict({ code: 'check_mode' }).then(res => {
                this.checkModeList = res.data.data;
            })
            queryDict({ code: 'activity_direction' }).then(res => {
                this.activityDirList = res.data.data;
            })
        },
        queryOrgList() {
            queryUserManagerOrg().then(res => {
                if (res.data.code === 1) {
                    this.orgList = res.data.data;
                } else {
                    this.$message.error("请求出错")
                }
            })
        },
        changePeriod() {
            this.form.gradeKey = '';
            this.form.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.form.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
        },
        changeGrade() {
            this.form.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.form.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.form.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
        },
        changeCheckMode() {
        },
        getGeocoder(e) {
            if (this.form.isEva === 1) {
                this.form.lat = e.center[1];
                this.form.lng = e.center[0];
                this.form.evaAddress = e.formattedAddress;
            }
        },
        handleCoverSuccess(response, uploadFile) {
            if (uploadFile.response.code === 1) {
                this.form.activityCover = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeAvatarUpload(rawFile) {
            if (!(rawFile.type === 'image/jpeg' ||
                rawFile.type === 'image/png' ||
                rawFile.type === 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.form.imgUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        backList() {
            this.$router.push({
                path: "/activity",
            });
        },
        disabledDate(current) {
            return current && current < Number(new Date()) - 86400000
        },
        handleFileChange(file) {},
        beforeFileUpload(rawFile) {
            if (!(rawFile.type === 'application/pdf' ||
                rawFile.type === 'application/vnd.ms-powerpoint' ||
                rawFile.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
                rawFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                rawFile.type === 'application/msword')) {
                this.$message.error('文件格式不支持')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
        previewScale(item) {
            infoScale({ scaleId: item.scaleId }).then(res => {
                this.scaleInfo = res.data.data;
                this.isViewScaleShow = true;
            })
        },
        verifyLeadUsersList(rule, value, callback) {
            if (this.$refs.leadUsersList.checkList.length === 0) {
                callback(new Error('请选择活动负责人'))
            } else {
                callback()
            }
        },
        verifyCsCheckUsersList(rule, value, callback) {
            if (this.form.checkMode === '2') {
                if (this.$refs.csCheckUsersList.checkList.length === 0) {
                    callback(new Error('请选择初审审核人'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        },
        verifyFsCheckUsersList(rule, value, callback) {
            if (this.form.checkMode === '3') {
                if (this.$refs.fsCheckUsersList.checkList.length === 0) {
                    callback(new Error('请选择复审审核人'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        },
        verifyZsCheckUsersList(rule, value, callback) {
            if (this.$refs.zsCheckUsersList.checkList.length === 0) {
                callback(new Error('请选择终审审核人'))
            } else {
                callback()
            }
        },
        verifyApplyFormTime(rule, value, callback) {
            if (this.form.beginTime === '' || !this.form.beginTime) {
                callback(new Error('请选择开始时间'))
            } else if (this.form.endTime === '' || !this.form.endTime) {
                callback(new Error('请选择结束时间'))
            } else if (this.form.endTime < this.form.beginTime) {
                this.form.endTime = ''
                callback(new Error('结束时间必须在开始时间之后'))
            } else {
                callback()
            }
        },
        verifyCsCheckFormTime(rule, value, callback) {
            if (this.form.endTime === '' || !this.form.endTime) {
                this.form.csBeginTime = ''
                callback(new Error('请选择报名时间'))
            } else if (this.form.csBeginTime === '' || !this.form.csBeginTime) {
                callback(new Error('请选择开始时间'))
            } else if (this.form.csBeginTime < this.form.endTime) {
                this.form.csBeginTime = ''
                callback(new Error('初审开始时间需在报名结束时间之后'))
            } else if (this.form.csEndTime === '' || !this.form.csEndTime) {
                callback(new Error('请选择结束时间'))
            } else if (this.form.csEndTime < this.form.csBeginTime) {
                this.form.csEndTime = ''
                callback(new Error('结束时间必须在开始时间之后'))
            } else {
                callback()
            }
        },
        verifyFsCheckFormTime(rule, value, callback) {
            if (this.form.csEndTime === '' || !this.form.csEndTime) {
                this.form.fsBeginTime = ''
                callback(new Error('请选择报名时间'))
            } else if (this.form.fsBeginTime === '' || !this.form.fsBeginTime) {
                callback(new Error('请选择开始时间'))
            } else if (this.form.fsBeginTime < this.form.csBeginTime) {
                this.form.fsBeginTime = ''
                callback(new Error('复审开始时间需在初审结束时间之后'))
            } else if (this.form.fsEndTime === '' || !this.form.fsEndTime) {
                callback(new Error('请选择结束时间'))
            } else if (this.form.fsEndTime < this.form.fsBeginTime) {
                this.form.csEndTime = ''
                callback(new Error('结束时间必须在开始时间之后'))
            } else {
                callback()
            }
        },
        verifyZsCheckFormTime(rule, value, callback) {
            if (this.form.checkMode === '1') {
                if (this.form.endTime === '' || !this.form.endTime) {
                    this.form.zsBeginTime = ''
                    callback(new Error('请选择报名结束时间'))
                } else if (this.form.zsBeginTime === '' || !this.form.zsBeginTime) {
                    callback(new Error('请选择开始时间'))
                } else if (this.form.endTime > this.form.zsBeginTime) {
                    this.form.zsBeginTime = ''
                    callback(new Error('终审开始时间需在报名结束时间之后'))
                } else if (this.form.zsEndTime === '' || !this.form.zsEndTime) {
                    callback(new Error('请选择结束时间'))
                } else if (this.form.zsEndTime < this.form.zsBeginTime) {
                    this.form.zsEndTime = ''
                    callback(new Error('结束时间必须在开始时间之后'))
                } else {
                    callback()
                }
            } else if (this.form.checkMode === '2') {
                if (this.form.csEndTime === '' || !this.form.csEndTime) {
                    this.form.zsBeginTime = ''
                    callback(new Error('请选择报名结束时间'))
                } else if (this.form.zsBeginTime === '' || !this.form.zsBeginTime) {
                    callback(new Error('请选择开始时间'))
                } else if (this.form.csEndTime > this.form.zsBeginTime) {
                    this.form.zsBeginTime = ''
                    callback(new Error('终审开始时间需在初审结束时间之后'))
                } else if (this.form.zsEndTime === '' || !this.form.zsEndTime) {
                    callback(new Error('请选择结束时间'))
                } else if (this.form.zsEndTime < this.form.zsBeginTime) {
                    this.form.zsEndTime = ''
                    callback(new Error('结束时间必须在开始时间之后'))
                } else {
                    callback()
                }
            } else if (this.form.checkMode === '3') {
                if (this.form.fsEndTime === '' || !this.form.fsEndTime) {
                    this.form.zsBeginTime = ''
                    callback(new Error('请选择报名结束时间'))
                } else if (this.form.zsBeginTime === '' || !this.form.zsBeginTime) {
                    callback(new Error('请选择开始时间'))
                } else if (this.form.fsEndTime > this.form.zsBeginTime) {
                    this.form.zsBeginTime = ''
                    callback(new Error('终审开始时间需在复审结束时间之后'))
                } else if (this.form.zsEndTime === '' || !this.form.zsEndTime) {
                    callback(new Error('请选择结束时间'))
                } else if (this.form.zsEndTime < this.form.zsBeginTime) {
                    this.form.zsEndTime = ''
                    callback(new Error('结束时间必须在开始时间之后'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        },
        verifyPbCheckFormTime(rule, value, callback) {
            if (this.form.zsEndTime === '' || !this.form.zsEndTime) {
                this.form.evaBeginTime = ''
                callback(new Error('请选择终审时间'))
            } else if (this.form.evaBeginTime === '' || !this.form.evaBeginTime) {
                callback(new Error('请选择开始时间'))
            } else if (this.form.evaBeginTime < this.form.zsEndTime) {
                this.form.evaBeginTime = ''
                callback(new Error('评比开始时间需在终审结束时间之后'))
            } else if (this.form.evaEndTime === '' || !this.form.evaEndTime) {
                callback(new Error('请选择结束时间'))
            } else if (this.form.evaEndTime < this.form.evaBeginTime) {
                this.form.evaEndTime = ''
                callback(new Error('结束时间必须在开始时间之后'))
            } else {
                callback()
            }
        },
        submitActivity() {
            const fileList = [];
            this.fileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.form.fileUrls = fileList.toString();
            if (this.$refs.leadUsersList.checkList.length !== 0) {
                this.form.activityLeader = this.$refs.leadUsersList.checkList[0].userId;
            } else {
                this.form.activityLeader = '';
            }
            if (this.form.checkMode === '2' || this.form.checkMode === '3') {
                this.form.csCheckUsersList = [];
                this.$refs.csCheckUsersList.checkList.forEach(e => {
                    this.form.csCheckUsersList.push(e.userId)
                })
                this.form.csCheckUsers = this.form.csCheckUsersList.toString()
            }
            if (this.form.checkMode === '3') {
                this.form.fsCheckUsersList = [];
                this.$refs.fsCheckUsersList.checkList.forEach(e => {
                    this.form.fsCheckUsersList.push(e.userId)
                })
                this.form.fsCheckUsers = this.form.fsCheckUsersList.toString()
            }
            this.form.zsCheckUsersList = [];
            this.$refs.zsCheckUsersList.checkList.forEach(e => {
                this.form.zsCheckUsersList.push(e.userId)
            })
            this.form.zsCheckUsers = this.form.zsCheckUsersList.toString()
            this.$refs["form"].validate(valid => {
                if (valid) {
                    const loading = ElLoading.service({ fullscreen: true })
                    if (this.activityId) {
                        activityUpdate(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("保存成功");
                                this.backList()
                                loading.close()
                            } else {
                                this.$message.error("操作失败")
                                loading.close()
                            }
                        })
                    } else {
                        activityCreate(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("保存成功");
                                this.backList()
                                loading.close()
                            } else {
                                this.$message.error("操作失败")
                                loading.close()
                            }
                        })
                    }
                }
            })
        },
        createActivityDirection() {
            this.dirName = ''
            this.dirNameShow = true;
        },
        submitDirName() {
            addActivityDirection({ dirName: this.dirName }).then(res => {
                if (res.data.code === 1) {
                    this.queryDict();
                    this.$message.success('添加成功')
                    this.dirNameShow = false;
                } else {
                    this.$message.error('添加失败')
                }
            })
        },
        queryActivityScaleList() {
            this.queryForm.scaleType = 1;
            listScale(this.queryForm).then(res => {
                this.fsScaleList = res.data.data;
            })
            this.queryForm.scaleType = 2;
            listScale(this.queryForm).then(res => {
                this.zsScaleList = res.data.data;
            })
        },
        checkCoverValidator(rule, value, callback) {
            if (this.form.imgUrl !== '') {
                callback()
            } else {
                callback(new Error('请上传详情图片'))
            }
        },
    }
};
</script>

<style scoped>
.event-avatar-uploader .avatar {
    height: 152px;
    width: 270px;
    display: block;
    object-fit: cover;
}
.event-avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.event-avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.event-avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    height: 152px;
    width: 270px;
    text-align: center;
}
.avatar-uploader .avatar {
    width: 270px;
    height: 152px;
    display: block;
    object-fit: cover;
}
.avatar-uploader /deep/ .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 270px;
    height: 152px;
    text-align: center;
}
.info-column-container {
    display: flex;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #377f7f;
    margin-bottom: 10px;
}
.column-title {
    height: 20px;
    line-height: 20px;
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #377f7f;
    font-size: 16px;
    text-indent: 5px;
    width: 100px;
}
.info-content-container {
    width: 100%;
    height: auto;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.topic-title-container {
    width: 100%;
    height: 40px;
    display: flex;
}
.topic-title-container1 {
    width: 30px;
    height: 40px;
    box-sizing: border-box;
    padding-top: 10px;
}
.topic-title-container2 {
    width: 110px;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #377f7f;
}
.topic-title-container3 {
    width: calc(100% - 140px);
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #377f7f;
}
.cus-btn {
    padding-bottom: 15px;
}
.cus-btn .el-button--primary {
    background-color: #377f7f;
    border-color: #377f7f;
}
.text-center {
    text-align: center;
}
</style>
